import { render } from "./ProxyFundingAccountComponent.vue?vue&type=template&id=685ca5a6&scoped=true"
import script from "./ProxyFundingAccountComponent.vue?vue&type=script&lang=js"
export * from "./ProxyFundingAccountComponent.vue?vue&type=script&lang=js"

import "./ProxyFundingAccountComponent.vue?vue&type=style&index=0&id=685ca5a6&lang=css"
import "./ProxyFundingAccountComponent.vue?vue&type=style&index=1&id=685ca5a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685ca5a6"]])

export default __exports__